/*
* Copyright (C) Regione Lombardia
*/
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { RilievoService } from '@shared/services/rilievo.service';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-pages-gestione-rilievo-crea-rilievo',
    templateUrl: './crea-rilievo.component.html',
})
export class PagesGestioneRilievoCreaRilievoComponent implements OnInit{

    public criteriaForm: FormGroup;

    constructor(
        private rilievoService: RilievoService,
        private utilsService: UtilsService,
        private route: ActivatedRoute,
        private router: Router
    ) { }
    
    ngOnInit() {
        this.criteriaForm = this.rilievoService.generateFormRilievo();
    }

    public inserisciRilievo() {
        if (this.criteriaForm.invalid) {
            this.utilsService.showWarning(CoreI18nConfigs.messages.fieldRequired);
            this.criteriaForm.markAllAsTouched();
            return;
        } else if(this.criteriaForm.get('dataInizioRilievo')?.value && this.criteriaForm.get('dataFineRilievo')?.value &&(new Date(this.criteriaForm.get('dataInizioRilievo')?.value).getTime() > new Date(this.criteriaForm.get('dataFineRilievo')?.value).getTime())) {
            this.utilsService.showWarning('La data di inizio rilievo dev\'essere minore o uguale a quella di fine.');
            return;
        }
        this.rilievoService.create(this.criteriaForm.getRawValue()).subscribe(response => {
            this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
            this.router.navigate(['..'], { relativeTo: this.route });
        });
    }



}
